import { ReducerUtil } from 'doctivity-shared/utils';

import {
  API_DOCUMENTS_TABLE,
  API_DOCUMENTS_LIST,
  API_DOCUMENTS_UPSERT,
} from 'store/actions/documentsActions';

export const documents = (state = {}, action = null) => {
  const result = ReducerUtil.simpleReduce(
    state,
    action,
    API_DOCUMENTS_TABLE,
    API_DOCUMENTS_LIST,
    API_DOCUMENTS_UPSERT,
  );
  if (result.actionConsumed) {
    return result.state;
  }
  return state;
};
